import Attrs from '../models/Attrs'
import type { Chart } from '../models/types'

const CONTROLLER = 'components--chart'
export default function renderChart(component: Chart, attrs: Attrs): string {
  attrs
    .addController(CONTROLLER)
    .addValueIfExists(CONTROLLER, 'src', component?.src)
    .addController('template') //LUCIAN - Not sure about this, what I want is to accept templating in some component properties like data.labels
  return `<div><canvas ${attrs.toString()}></canvas></div>`
}
